import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from '@/components/layout/AdminLayout';
import ProtectedRoute from '@/components/auth/ProtectedRoute';
import { PermissionProtectedRoute } from '@/components/auth/PermissionProtectedRoute';
import { UnauthorizedPage } from '@/pages/UnauthorizedPage';
import LoginPage from '@/pages/LoginPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import { CaptainOverviewPage } from '@/pages/overview/CaptainOverviewPage';
import SystemOverview from '@/pages/SystemOverview';
import SiteSettingsPage from '@/pages/SiteSettingsPage';
import SalesPage from '@/pages/SalesPage';
import MembershipsPage from '@/pages/MembershipsPage';
import TrafficPage from '@/pages/TrafficPage';
import ConversionsPage from '@/pages/ConversionsPage';
import ApiDiagnosticsPage from '@/pages/ApiDiagnosticsPage';
import RenewalsPage from '@/pages/RenewalsPage';
import UsersPage from '@/pages/UsersPage';
import ExportsPage from '@/pages/ExportsPage';
import SettingsPage from '@/pages/SettingsPage';
import PageStatusPage from '@/pages/settings/PageStatusPage';
import PlansListPage from '@/pages/plans/PlansListPage';
import PlanEditorPage from '@/pages/plans/PlanEditorPage';
import AuditLogPage from '@/pages/audit/AuditLogPage';
import WarrantyOverviewPage from '@/pages/warranty/WarrantyOverviewPage';
import WarrantyEquipmentPage from '@/pages/warranty/WarrantyEquipmentPage';
import WarrantyAgreementsPage from '@/pages/warranty/WarrantyAgreementsPage';
import WarrantyClaimsPage from '@/pages/warranty/WarrantyClaimsPage';
import WarrantyContractorsPage from '@/pages/warranty/WarrantyContractorsPage';
import WarrantyReportsPage from '@/pages/warranty/WarrantyReportsPage';
import WarrantyCoveragePage from '@/pages/warranty/WarrantyCoveragePage';
import ComplianceDashboard from '@/pages/warranty/ComplianceDashboard';
import TestPage from '@/pages/TestPage';
import CreateAdminPage from '@/pages/CreateAdminPage';
import FixDatabasePage from '@/pages/FixDatabasePage';
import CustomersListPage from '@/pages/customers/CustomersListPage';
import CustomerImportTriggerPage from '@/pages/integrations/CustomerImportTriggerPage';
import CustomerDetailPage from '@/pages/customers/CustomerDetailPage';
import ImportSampleDataPage from '@/pages/customers/ImportSampleDataPage';
import TestSingleCompanyPage from '@/pages/customers/TestSingleCompanyPage';
import ReviewsManagementPage from '@/pages/reviews/ReviewsManagementPage';
import ReviewRequestsPage from '@/pages/reviews/ReviewRequestsPage';
import FullHistoricalImportPage from '@/pages/customers/FullHistoricalImportPage';
import ImportManagementPage from '@/pages/integrations/ImportManagementPage';
import SuccessWareFullImportPage from '@/pages/integrations/SuccessWareFullImportPage';
import SuccessWareIncrementalImportPage from '@/pages/integrations/SuccessWareIncrementalImportPage';
import IncrementalTrueUpPage from '@/pages/integrations/IncrementalTrueUpPage';
import SuccessWareTrueUpPage from '@/pages/integrations/SuccessWareTrueUpPage';
import DataIngestionVisualizationPage from '@/pages/integrations/DataIngestionVisualizationPage';
import GoHighLevelPage from '@/pages/integrations/GoHighLevelPage';
import IntegrationsPage from '@/pages/integrations/IntegrationsPage';
import RahsReviewsIntegrationPage from '@/pages/settings/IntegrationsPage';
import SuccessWarePage from '@/pages/integrations/SuccessWarePage';
import SuccessWareCredentialsPage from '@/pages/integrations/SuccessWareCredentialsPage';
import SuccessWareFieldCatalogPage from '@/pages/integrations/SuccessWareFieldCatalogPage';
import SuccessWareActivityMonitorPage from '@/pages/integrations/SuccessWareActivityMonitorPage';
import SuccessWareBookItTestPage from '@/pages/integrations/SuccessWareBookItTestPage';
import SuccessWareApiExplorerPage from '@/pages/integrations/SuccessWareApiExplorerPage';
import OperationCatalogPage from '@/pages/integrations/OperationCatalogPage';
import ApiRunnerPage from '@/pages/integrations/ApiRunnerPage';
import LogsHealthPage from '@/pages/integrations/LogsHealthPage';
import MonitoringPage from '@/pages/MonitoringPage';
import ErrorsPage from '@/pages/ErrorsPage';
import AnalyticsPage from '@/pages/AnalyticsPage';
import PerformancePage from '@/pages/PerformancePage';
import AgentDesktop from '@/pages/call-center/AgentDesktop';
import ManagerDashboard from '@/pages/call-center/ManagerDashboard';
import CallCenterOverview from '@/pages/call-center/CallCenterOverview';
import AgentConsole from '@/pages/contact-center/AgentConsole';
import SupervisorDashboard from '@/pages/contact-center/SupervisorDashboard';
import SupervisorMonitoring from '@/pages/contact-center/SupervisorMonitoring';
import CallHistory from '@/pages/contact-center/CallHistory';
import CallAnalytics from '@/pages/contact-center/CallAnalytics';
import CallConversions from '@/pages/contact-center/CallConversions';
import CallSaverQueue from '@/pages/contact-center/CallSaverQueue';
import CallGradingGuidePage from '@/pages/contact-center/CallGradingGuidePage';
import DNIAttribution from '@/pages/contact-center/DNIAttribution';
import QueueManagement from '@/pages/contact-center/QueueManagement';
import ActiveCallsMonitor from '@/pages/contact-center/ActiveCallsMonitor';
import CallCenterSettings from '@/pages/contact-center/CallCenterSettings';
import GenesysIntegration from '@/pages/settings/GenesysIntegration';
import SMSAnalytics from '@/pages/messaging/SMSAnalytics';
import SMSSettings from '@/pages/messaging/SMSSettings';
import VendorManagement from '@/pages/vendors/VendorManagement';
import VendorDocuments from '@/pages/vendors/VendorDocuments';
import RevenueReporting from '@/pages/reports/RevenueReporting';
import ClaimsRatioAnalysis from '@/pages/reports/ClaimsRatioAnalysis';
import FormsLibraryManagement from '@/pages/forms/FormsLibraryManagement';
import AssociationsManagement from '@/pages/associations/AssociationsManagement';
import PropertyManagementPage from '@/pages/associations/PropertyManagementPage';
import UnitDetailPage from '@/pages/associations/UnitDetailPage';
import BulkOperations from '@/components/associations/BulkOperations';
import DispatchDashboard from '@/pages/dispatch/DispatchDashboard';
import JobAssignmentPage from '@/pages/dispatch/JobAssignmentPage';
import PartsRequestsPage from '@/pages/parts/PartsRequestsPage';
import PartsRequestDetailPage from '@/pages/parts/PartsRequestDetailPage';
import PaymentProcessingPage from '@/pages/payments/PaymentProcessingPage';
import TransactionHistoryPage from '@/pages/payments/TransactionHistoryPage';

// Import AI Voice Agent pages
import AIVoiceAgentsOverview from '@/pages/ai-voice-agents/AIVoiceAgentsOverview';
import CompaniesPage from '@/pages/ai-voice-agents/CompaniesPage';
import KnowledgeBasePage from '@/pages/ai-voice-agents/KnowledgeBasePage';
import RulesPage from '@/pages/ai-voice-agents/RulesPage';
import PhoneNumbersPage from '@/pages/ai-voice-agents/PhoneNumbersPage';
import PerformanceDashboard from '@/pages/ai-voice-agents/PerformanceDashboard';
import CompanyMcpSettings from '@/pages/ai-voice-agents/CompanyMcpSettings';
import AgentScriptsPage from '@/pages/ai-voice-agents/AgentScriptsPage';
import AgentRulesPage from '@/pages/ai-voice-agents/AgentRulesPage';
import AgentKnowledgeBasePage from '@/pages/ai-voice-agents/AgentKnowledgeBasePage';
import AgentFAQsPage from '@/pages/ai-voice-agents/AgentFAQsPage';
import HardRulesPage from '@/pages/ai-voice-agents/HardRulesPage';
import AgentScriptsCompilerPage from '@/pages/ai-voice-agents/AgentScriptsCompilerPage';
import BatchCallingPage from '@/pages/ai-voice-agents/BatchCallingPage';

// Import Database Reference
import DatabaseReferencePage from '@/pages/database-reference/DatabaseReferencePage';

// Import accounting module
import AccountingModule from '@/modules/accounting';
import { ComingSoon } from '@/components/common/ComingSoon';

const AppRoutes = () => (
  <Routes>
    {/* Public routes */}
    <Route path="/login" element={<LoginPage />} />
    <Route path="/reset-password" element={<ResetPasswordPage />} />
    <Route path="/unauthorized" element={<UnauthorizedPage />} />
    <Route path="/test" element={<TestPage />} />
    <Route path="/create-admin" element={<CreateAdminPage />} />
    <Route path="/fix-database" element={<FixDatabasePage />} />

    {/* Protected admin routes */}
    <Route path="/" element={
      <ProtectedRoute>
        <AdminLayout />
      </ProtectedRoute>
    }>
      <Route index element={<CaptainOverviewPage />} />
      <Route path="system" element={
        <PermissionProtectedRoute requiredPermission="monitoring">
          <SystemOverview />
        </PermissionProtectedRoute>
      } />
      <Route path="plans" element={
        <PermissionProtectedRoute requiredPermission="plans">
          <PlansListPage />
        </PermissionProtectedRoute>
      } />
      <Route path="plans/new" element={
        <PermissionProtectedRoute requiredPermission="plans">
          <PlanEditorPage mode="create" />
        </PermissionProtectedRoute>
      } />
      <Route path="plans/:planId/*" element={
        <PermissionProtectedRoute requiredPermission="plans">
          <PlanEditorPage />
        </PermissionProtectedRoute>
      } />
      <Route path="customers" element={
        <PermissionProtectedRoute requiredPermission="customers">
          <CustomersListPage />
        </PermissionProtectedRoute>
      } />
      <Route path="customers/:id" element={
        <PermissionProtectedRoute requiredPermission="customers">
          <CustomerDetailPage />
        </PermissionProtectedRoute>
      } />
      <Route path="customers/import" element={
        <PermissionProtectedRoute requiredPermission="customers">
          <ImportSampleDataPage />
        </PermissionProtectedRoute>
      } />
      <Route path="customers/export" element={
        <PermissionProtectedRoute requiredPermission="customers">
          <ComingSoon title="Customer Export" />
        </PermissionProtectedRoute>
      } />
      <Route path="customers/merge" element={
        <PermissionProtectedRoute requiredPermission="customers">
          <ComingSoon title="Customer Merge" />
        </PermissionProtectedRoute>
      } />
      <Route path="customers/test" element={
        <PermissionProtectedRoute requiredPermission="customers">
          <TestSingleCompanyPage />
        </PermissionProtectedRoute>
      } />
      <Route path="reviews" element={
        <PermissionProtectedRoute requiredPermission="reviews">
          <ReviewsManagementPage />
        </PermissionProtectedRoute>
      } />
      <Route path="reviews/requests" element={
        <PermissionProtectedRoute requiredPermission="reviews">
          <ReviewRequestsPage />
        </PermissionProtectedRoute>
      } />
      <Route path="reviews/dashboard" element={
        <PermissionProtectedRoute requiredPermission="reviews">
          <ComingSoon title="Reviews Dashboard" />
        </PermissionProtectedRoute>
      } />
      <Route path="reviews/responses" element={
        <PermissionProtectedRoute requiredPermission="reviews">
          <ComingSoon title="Review Responses" />
        </PermissionProtectedRoute>
      } />
      <Route path="customers/full-import" element={
        <PermissionProtectedRoute requiredPermission="imports">
          <FullHistoricalImportPage />
        </PermissionProtectedRoute>
      } />
      <Route path="integrations" element={
        <PermissionProtectedRoute requiredPermission="integrations">
          <IntegrationsPage />
        </PermissionProtectedRoute>
      } />
          <Route path="integrations/imports" element={
            <PermissionProtectedRoute requiredPermission="imports">
              <ImportManagementPage />
            </PermissionProtectedRoute>
          } />
          <Route path="integrations/full-import" element={
            <PermissionProtectedRoute requiredPermission="imports">
              <SuccessWareFullImportPage />
            </PermissionProtectedRoute>
          } />
          <Route path="integrations/incremental-import" element={
            <PermissionProtectedRoute requiredPermission="imports">
              <SuccessWareIncrementalImportPage />
            </PermissionProtectedRoute>
          } />
          <Route path="integrations/customer-import" element={
            <PermissionProtectedRoute requiredPermission="imports">
              <CustomerImportTriggerPage />
            </PermissionProtectedRoute>
          } />
          <Route path="integrations/true-up" element={
            <PermissionProtectedRoute requiredPermission="imports">
              <IncrementalTrueUpPage />
            </PermissionProtectedRoute>
          } />
          <Route path="integrations/successware-true-up" element={
            <PermissionProtectedRoute requiredPermission="imports">
              <SuccessWareTrueUpPage />
            </PermissionProtectedRoute>
          } />
          <Route path="integrations/data-ingestion" element={
            <PermissionProtectedRoute requiredPermission="imports">
              <DataIngestionVisualizationPage />
            </PermissionProtectedRoute>
          } />
      <Route path="integrations/successware" element={
        <PermissionProtectedRoute requiredPermission="integrations">
          <SuccessWarePage />
        </PermissionProtectedRoute>
      } />
      <Route path="integrations/successware/credentials" element={
        <PermissionProtectedRoute requiredPermission="integrations">
          <SuccessWareCredentialsPage />
        </PermissionProtectedRoute>
      } />
      <Route path="integrations/successware/catalog" element={
        <PermissionProtectedRoute requiredPermission="integrations">
          <OperationCatalogPage />
        </PermissionProtectedRoute>
      } />
      <Route path="integrations/successware/fields" element={
        <PermissionProtectedRoute requiredPermission="integrations">
          <SuccessWareFieldCatalogPage />
        </PermissionProtectedRoute>
      } />
      <Route path="integrations/successware/activity" element={
        <PermissionProtectedRoute requiredPermission="integrations">
          <SuccessWareActivityMonitorPage />
        </PermissionProtectedRoute>
      } />
      <Route path="integrations/successware/runner" element={
        <PermissionProtectedRoute requiredPermission="integrations">
          <ApiRunnerPage />
        </PermissionProtectedRoute>
      } />
      <Route path="integrations/successware/bookit-test" element={
        <PermissionProtectedRoute requiredPermission="integrations">
          <SuccessWareBookItTestPage />
        </PermissionProtectedRoute>
      } />
      <Route path="integrations/successware/api-explorer" element={
        <PermissionProtectedRoute requiredPermission="integrations">
          <SuccessWareApiExplorerPage />
        </PermissionProtectedRoute>
      } />
      <Route path="integrations/successware/logs" element={
        <PermissionProtectedRoute requiredPermission="integrations">
          <LogsHealthPage />
        </PermissionProtectedRoute>
      } />
      <Route path="integrations/gohighlevel" element={
        <PermissionProtectedRoute requiredPermission="integrations">
          <GoHighLevelPage />
        </PermissionProtectedRoute>
      } />
      <Route path="integrations/rahsreviews" element={
        <PermissionProtectedRoute requiredPermission="integrations">
          <RahsReviewsIntegrationPage />
        </PermissionProtectedRoute>
      } />
      <Route path="settings/integrations/genesys" element={
        <PermissionProtectedRoute requiredPermission="settings">
          <GenesysIntegration />
        </PermissionProtectedRoute>
      } />
      <Route path="sales" element={
        <PermissionProtectedRoute requiredPermission="sales">
          <SalesPage />
        </PermissionProtectedRoute>
      } />
      <Route path="memberships" element={
        <PermissionProtectedRoute requiredPermission="memberships">
          <MembershipsPage />
        </PermissionProtectedRoute>
      } />
      <Route path="traffic" element={
        <PermissionProtectedRoute requiredPermission="traffic">
          <TrafficPage />
        </PermissionProtectedRoute>
      } />
      <Route path="conversions" element={
        <PermissionProtectedRoute requiredPermission="conversions">
          <ConversionsPage />
        </PermissionProtectedRoute>
      } />
      <Route path="api" element={
        <PermissionProtectedRoute requiredPermission="api">
          <ApiDiagnosticsPage />
        </PermissionProtectedRoute>
      } />
      <Route path="renewals" element={
        <PermissionProtectedRoute requiredPermission="renewals">
          <RenewalsPage />
        </PermissionProtectedRoute>
      } />
      <Route path="audit" element={
        <PermissionProtectedRoute requiredPermission="audit">
          <AuditLogPage />
        </PermissionProtectedRoute>
      } />
      <Route path="users" element={
        <PermissionProtectedRoute requiredPermission="users">
          <UsersPage />
        </PermissionProtectedRoute>
      } />
      <Route path="exports" element={
        <PermissionProtectedRoute requiredPermission="exports">
          <ExportsPage />
        </PermissionProtectedRoute>
      } />
      <Route path="settings" element={
        <PermissionProtectedRoute requiredPermission="settings">
          <SettingsPage />
        </PermissionProtectedRoute>
      } />
      <Route path="settings/page-status" element={
        <PermissionProtectedRoute requiredPermission="settings">
          <PageStatusPage />
        </PermissionProtectedRoute>
      } />
      <Route path="site-settings" element={
        <PermissionProtectedRoute requiredPermission="settings">
          <SiteSettingsPage />
        </PermissionProtectedRoute>
      } />

      {/* Monitoring & Analytics Routes */}
      <Route path="monitoring" element={
        <PermissionProtectedRoute requiredPermission="monitoring">
          <MonitoringPage />
        </PermissionProtectedRoute>
      } />
      <Route path="errors" element={
        <PermissionProtectedRoute requiredPermission="errors">
          <ErrorsPage />
        </PermissionProtectedRoute>
      } />
      <Route path="analytics" element={
        <PermissionProtectedRoute requiredPermission="analytics">
          <AnalyticsPage />
        </PermissionProtectedRoute>
      } />
      <Route path="performance" element={
        <PermissionProtectedRoute requiredPermission="performance">
          <PerformancePage />
        </PermissionProtectedRoute>
      } />

      {/* Call Center Routes */}
      <Route path="call-center" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "contact_center"]}>
          <CallCenterOverview />
        </PermissionProtectedRoute>
      } />
      <Route path="call-center/agent" element={<Navigate to="/contact-center/agent-console" replace />} />
      <Route path="call-center/manager" element={<Navigate to="/contact-center/supervisor" replace />} />
      <Route path="contact-center" element={<Navigate to="/contact-center/supervisor" replace />} />
      <Route path="contact-center/agent-console" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "contact_center"]}>
          <AgentConsole />
        </PermissionProtectedRoute>
      } />
      <Route path="contact-center/supervisor" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "contact_center"]}>
          <SupervisorDashboard />
        </PermissionProtectedRoute>
      } />
      <Route path="contact-center/conversions" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "contact_center"]}>
          <CallConversions />
        </PermissionProtectedRoute>
      } />
      <Route path="contact-center/call-saver" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "contact_center"]}>
          <CallSaverQueue />
        </PermissionProtectedRoute>
      } />
      <Route path="contact-center/grading-guide" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "contact_center"]}>
          <CallGradingGuidePage />
        </PermissionProtectedRoute>
      } />
      <Route path="contact-center/call-history" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "contact_center"]}>
          <CallHistory />
        </PermissionProtectedRoute>
      } />
      <Route path="contact-center/analytics" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "contact_center"]}>
          <CallAnalytics />
        </PermissionProtectedRoute>
      } />
      <Route path="contact-center/dni-attribution" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "contact_center"]}>
          <DNIAttribution />
        </PermissionProtectedRoute>
      } />
      <Route path="contact-center/queue-management" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "contact_center"]}>
          <QueueManagement />
        </PermissionProtectedRoute>
      } />
      <Route path="contact-center/active-calls" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "contact_center"]}>
          <ActiveCallsMonitor />
        </PermissionProtectedRoute>
      } />
      <Route path="contact-center/settings" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "contact_center"]}>
          <CallCenterSettings />
        </PermissionProtectedRoute>
      } />
      <Route path="contact-center/supervisor-monitoring" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "contact_center"]}>
          <SupervisorMonitoring />
        </PermissionProtectedRoute>
      } />

      {/* SMS/Messaging Routes */}
      <Route path="messaging/sms-analytics" element={<SMSAnalytics />} />
      <Route path="messaging/sms-settings" element={<SMSSettings />} />

      {/* Vendor Management Routes */}
      <Route path="vendors" element={<VendorManagement />} />
      <Route path="vendors/:vendorId/documents" element={<VendorDocuments vendorId="" vendorName="" />} />

      {/* Reporting Routes */}
      <Route path="reports/revenue" element={<RevenueReporting />} />
      <Route path="reports/claims-ratio" element={<ClaimsRatioAnalysis />} />

      {/* Forms Library Routes */}
      <Route path="forms" element={<FormsLibraryManagement />} />
      <Route path="forms/management" element={<ComingSoon title="Form Management" />} />

      {/* Parts Request Routes */}
      <Route path="parts" element={<PartsRequestsPage />} />
      <Route path="parts/:id" element={<PartsRequestDetailPage />} />
      <Route path="parts/inventory" element={<ComingSoon title="Parts Inventory" />} />
      <Route path="parts/requests" element={<ComingSoon title="Request Management" />} />

      {/* HOA/Associations Routes */}
      <Route path="associations" element={<AssociationsManagement />} />
      <Route path="associations/properties" element={<PropertyManagementPage />} />
      <Route path="associations/units/:unitId" element={<UnitDetailPage />} />
      <Route path="associations/bulk-operations" element={<BulkOperations />} />

      {/* Dispatch System Routes */}
      <Route path="dispatch" element={<DispatchDashboard />} />
      <Route path="dispatch/schedule" element={<DispatchDashboard />} />
      <Route path="dispatch/assignments" element={<JobAssignmentPage />} />
      <Route path="dispatch/technicians" element={<ComingSoon title="Technician Management" />} />

      {/* Payment System Routes */}
      <Route path="payments" element={<PaymentProcessingPage />} />
      <Route path="payments/history" element={<TransactionHistoryPage />} />
      <Route path="payments/reports" element={<ComingSoon title="Payment Reports" />} />
      <Route path="payments/settings" element={<ComingSoon title="Payment Settings" />} />

      {/* Accounting System Routes */}
      <Route path="accounting/*" element={<AccountingModule />} />

      {/* Warranty System Routes */}
      <Route path="warranty" element={
        <PermissionProtectedRoute requiredPermission="warranty">
          <WarrantyOverviewPage />
        </PermissionProtectedRoute>
      } />
      <Route path="warranty/dashboard" element={
        <PermissionProtectedRoute requiredPermission="warranty">
          <WarrantyOverviewPage />
        </PermissionProtectedRoute>
      } />
      <Route path="warranty/equipment" element={
        <PermissionProtectedRoute requiredPermission="warranty">
          <WarrantyEquipmentPage />
        </PermissionProtectedRoute>
      } />
      <Route path="warranty/agreements" element={
        <PermissionProtectedRoute requiredPermission="warranty">
          <WarrantyAgreementsPage />
        </PermissionProtectedRoute>
      } />
      <Route path="warranty/claims" element={
        <PermissionProtectedRoute requiredPermission="warranty">
          <WarrantyClaimsPage />
        </PermissionProtectedRoute>
      } />
      <Route path="warranty/contractors" element={
        <PermissionProtectedRoute requiredPermission="warranty">
          <WarrantyContractorsPage />
        </PermissionProtectedRoute>
      } />
      <Route path="warranty/coverage" element={
        <PermissionProtectedRoute requiredPermission="warranty">
          <WarrantyCoveragePage />
        </PermissionProtectedRoute>
      } />
      <Route path="warranty/reports" element={
        <PermissionProtectedRoute requiredPermission="warranty">
          <WarrantyReportsPage />
        </PermissionProtectedRoute>
      } />
      <Route path="warranty/compliance" element={
        <PermissionProtectedRoute requiredPermission="warranty">
          <ComplianceDashboard />
        </PermissionProtectedRoute>
      } />
      <Route path="warranty/policies" element={
        <PermissionProtectedRoute requiredPermission="warranty">
          <ComingSoon title="Warranty Policies" />
        </PermissionProtectedRoute>
      } />
      <Route path="warranty/customers" element={
        <PermissionProtectedRoute requiredPermission="warranty">
          <ComingSoon title="Warranty Customers" />
        </PermissionProtectedRoute>
      } />

      {/* AI Voice Agent Routes - requires call_center OR integrations permission */}
      <Route path="ai-voice-agents" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "integrations"]}>
          <AIVoiceAgentsOverview />
        </PermissionProtectedRoute>
      } />
      <Route path="ai-voice-agents/companies" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "integrations"]}>
          <CompaniesPage />
        </PermissionProtectedRoute>
      } />
      <Route path="ai-voice-agents/scripts" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "integrations"]}>
          <AgentScriptsPage />
        </PermissionProtectedRoute>
      } />
      <Route path="ai-voice-agents/compiler" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "integrations"]}>
          <AgentScriptsCompilerPage />
        </PermissionProtectedRoute>
      } />
      <Route path="ai-voice-agents/agent-rules" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "integrations"]}>
          <AgentRulesPage />
        </PermissionProtectedRoute>
      } />
      <Route path="ai-voice-agents/agent-knowledge" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "integrations"]}>
          <AgentKnowledgeBasePage />
        </PermissionProtectedRoute>
      } />
      <Route path="ai-voice-agents/agent-faqs" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "integrations"]}>
          <AgentFAQsPage />
        </PermissionProtectedRoute>
      } />
      <Route path="ai-voice-agents/hard-rules" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "integrations"]}>
          <HardRulesPage />
        </PermissionProtectedRoute>
      } />
      <Route path="ai-voice-agents/knowledge-base" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "integrations"]}>
          <KnowledgeBasePage />
        </PermissionProtectedRoute>
      } />
      <Route path="ai-voice-agents/rules" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "integrations"]}>
          <RulesPage />
        </PermissionProtectedRoute>
      } />
      <Route path="ai-voice-agents/mcp" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "integrations"]}>
          <CompanyMcpSettings />
        </PermissionProtectedRoute>
      } />
      <Route path="ai-voice-agents/phone-numbers" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "integrations"]}>
          <PhoneNumbersPage />
        </PermissionProtectedRoute>
      } />
      <Route path="ai-voice-agents/performance" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "integrations"]}>
          <PerformanceDashboard />
        </PermissionProtectedRoute>
      } />
      <Route path="ai-voice-agents/batch-calling" element={
        <PermissionProtectedRoute requiredPermission={["call_center", "integrations"]}>
          <BatchCallingPage />
        </PermissionProtectedRoute>
      } />

      {/* Database Reference - Master Reference for all database operations */}
      <Route path="database-reference" element={<DatabaseReferencePage />} />
    </Route>
  </Routes>
);

export default AppRoutes;
